import { render, staticRenderFns } from "./UserChangeActivationType.vue?vue&type=template&id=8993bee6&"
import script from "./UserChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./UserChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports